import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {useEditReplacement, useDetailLayout} from '@refra/modules/refra-static-parts/providers'

export const DetailSummary = () => {
  const {t} = useTranslation()
  const {totalAreaSelected, materialWeights} = useEditReplacement()
  const {isSectionsDrawerOpen, sectionsDrawerWidth} = useDetailLayout()

  const totalMaterialWeight = useMemo(
    () => materialWeights.reduce((acc, area) => acc + area.reduce((a, w) => a + w, 0), 0),
    [materialWeights]
  )

  const detailSummaryLeftOffset = isSectionsDrawerOpen
    ? `calc(${sectionsDrawerWidth} + 40px)`
    : '60px'

  return (
    <div
      className="absolute top-4 z-10 flex gap-4 rounded-lg border border-gray-100 bg-white p-3 shadow-md transition-[left] duration-300 ease-out"
      style={{left: detailSummaryLeftOffset}}
    >
      <div className="flex flex-col">
        <span className="text-xs text-gray-500">
          {t('staticParts.editReplacement.sections.selectedArea')}
        </span>
        <span className="text-sm font-semibold">{totalAreaSelected.toFixed(2)} m²</span>
      </div>
      <div className="flex flex-col">
        <span className="text-xs text-gray-500">
          {t('staticParts.editReplacement.sections.materialAmount')}
        </span>
        <span className="text-sm font-semibold">{totalMaterialWeight.toFixed(2)} t</span>
      </div>
      <div className="flex flex-col">
        <span className="text-xs text-gray-500">
          {t('staticParts.editReplacement.sections.cost')}
        </span>
        <span className="text-sm font-semibold">-</span>
      </div>
    </div>
  )
}
